// PRD-3334 meeting request: wording and options from the prototype (index_updated.html).

/** "When are you looking to hire?" at setup (signup config optionLists.hiringTimelines). */
export const URGENCY_SETUP = ["Right away", "Within the month", "Within 3 Months", "Later this year", "Just looking"];
/**
 * "When do you need someone in place?" in the meeting request. Asked fresh every time: it is a separate signal
 * from the setup answer and is never pre-filled from it (product, 2026-10-22).
 */
export const URGENCY_MEETING = ["Straight away", "Within a month", "In a couple of months", "No fixed date yet"];

export const VOIP = ["Yes, we have one", "No, we'd like help setting one up", "Not sure"];
/** Always visible beneath the VoIP answers: most people will not know what VoIP is. */
export const VOIP_HINT =
  "VoIP is a phone system that runs over the internet rather than a phone line. Your team member needs one to take and make calls as part of your practice.";

/** "How does your team access your EMR?" Worded as behaviour, not cloud or server, so owners can answer it. */
export const EMR_ACCESS = ["From anywhere, with login details", "Only from computers in the office", "Not sure"];

/** The system the access question names, by the industry given at setup; any other industry is not asked at all. */
export const RECORDS_SYSTEM: Record<string, string> = { Medical: "EMR", Dental: "EMR", Insurance: "AMS" };

/** "Fri 30 Oct" */
export const fmtCallDay = (d: Date) => d.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" });

/**
 * The window in minutes from midnight, every 30 minutes through office hours:
 * from 9:00 AM to 5:00 PM, to 10:00 AM to 6:00 PM, and "to" always after "from".
 */
const STEP = 30;
export const FROM_MINUTES = Array.from({ length: 8 * 2 + 1 }, (_, i) => 9 * 60 + i * STEP);
export const TO_MINUTES = Array.from({ length: 8 * 2 + 1 }, (_, i) => 10 * 60 + i * STEP);
export const DEFAULT_FROM = 9 * 60;
export const DEFAULT_TO = 10 * 60;

/** 570 → "9:30 AM", 780 → "1:00 PM". */
export function fmtMinutes(m: number): string {
  const h = Math.floor(m / 60) % 24;
  return `${h % 12 || 12}:${String(m % 60).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`;
}

/** What Edge sees as slot.time: "9:00 AM - 10:00 AM". */
export const fmtWindow = (from: number, to: number) => `${fmtMinutes(from)} - ${fmtMinutes(to)}`;
